import React from 'react';
import '../../../styles/eventsTouch.css';
import Modal3D from '../../ui/Modal3D';
import EscapeGuard from '../guests/EscapeGuard';

// Module 19 (BL-380) G8 - every Events Settings popup is the platform popup template (the Create-reservation 3D tile) in the settings
// skin. These popups hold typed values, so Escape never discards them (M6 rule); the x and Cancel still close.
export default function SettingsPopup({ title, subtitle, size = 'medium', testId, tileKey, onClose, actions, children }) {
    return (
        <EscapeGuard>
            <Modal3D
                portal
                size={size}
                title={title}
                subtitle={subtitle}
                onClose={onClose}
                className="ia-settings-popup"
                testId={testId || 'events-settings-popup'}
                data-events-settings-popup={tileKey}
                data-m6-layout="modals"
                data-m6-component="EventsSettingsPopup"
                actions={actions}
            >
                {children}
            </Modal3D>
        </EscapeGuard>
    );
}

// One labelled row in the popup's field grid (the Create-reservation field look).
export function Field({ id, label, children, wide = false, hint = null }) {
    return (
        <li className={`ia-resv-field${wide ? ' ia-resv-field--wide' : ''}`}>
            <div className="ia-resv-field__label"><label htmlFor={id}>{label}</label></div>
            {children}
            {hint && <p className="ia-resv-field__why">{hint}</p>}
        </li>
    );
}
